import React from 'react';

export default function AuthLayout({ children }) {
  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="feature-badge">Mustech Bulk SMS</div>
          <h2>Reach your customers instantly</h2>
          <p>Send personalized SMS campaigns to thousands of contacts in seconds with Mustech. Track delivery, manage contacts, and grow your business.</p>
          <ul className="feature-list">
            <li>
              <span className="feature-icon">✓</span>
              Bulk SMS to unlimited contacts
            </li>
            <li>
              <span className="feature-icon">✓</span>
              Real-time delivery reports
            </li>
            <li>
              <span className="feature-icon">✓</span>
              Sender ID customization
            </li>
            <li>
              <span className="feature-icon">✓</span>
              Scheduled campaigns
            </li>
            <li>
              <span className="feature-icon">✓</span>
              Contact group management
            </li>
          </ul>
        </div>
      </div>
      <div className="auth-right">
        {children}
      </div>
    </div>
  );
}
